import React from 'react';
import { capitalizeFirstLetter } from '../../../../../utils/formatString';

const shimmer =
  'relative overflow-hidden before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite] before:bg-gradient-to-r before:from-transparent before:via-white/40 before:to-transparent';
interface HeroSectionProps {
  studentDetails: {
    first_name: string;
  };
}

const HeroSection: React.FC<HeroSectionProps> = ({ studentDetails }) => {
  const studentFirstName = capitalizeFirstLetter(studentDetails ? studentDetails?.first_name : '');

  return (
    <>
      <section id="hero-section" className="w-full flex items-center justify-center bg-transparent">
        <div className="w-full max-w-[680px] flex flex-col gap-[10px] md:gap-[15px]">
          <p className="text-center text-[14px] md:text-[15px] font-[625] leading-[normal] text-[#ee731b] m-0">
            Designed With Your Goals in Mind
          </p>
          <h1 className="flex text-center text-[24px] md:text-[40px] font-semibold leading-[34px] md:leading-[50px] font-monaSans">
            {studentFirstName ? (
              `${studentFirstName}, your personalized fitness journey starts now`
            ) : (
              <div className="flex flex-col items-center w-full px-[40px] md:px-0">
                <div
                  className={`h-[26.5px] md:h-[42.5px] w-full md:w-[680px] bg-gray-200 dark:bg-gray-700 ${shimmer}`}
                />
                <div
                  className={`h-[26.5px] md:h-[42.5px] w-full md:w-[300px] bg-gray-200 dark:bg-gray-700 mt-[15px] ${shimmer}`}
                />
              </div>
            )}
          </h1>
          <p className="text-center text-[#868686] text-[15px] md:text-[17px] font-medium leading-[24px] md:leading-[26px] m-0">
            Over the next 3 months, we’ll follow a step-by-step plan tailored to your goals - built
            with expert guidance, care, and at a pace that fits your life.
          </p>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
